import { connect } from 'react-redux';
import { handOverChange } from '../../../../actions/filter';
import { IApplicationState, TTypedThunkDispatch } from '../../../../types/redux';
import { HandOver } from './HandOver';

export function mapStateToProps(state: IApplicationState) {
  return {
    value: state.filter.query.handOver,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    onChange: (value: boolean) => {
      dispatch(handOverChange(value));
    },
  };
}

export const HandOverField = connect(mapStateToProps, mapDispatchToProps)(HandOver);
